import Header from '../Header';
import { useInjectPanel } from '../../PanelContext';
import { formatValue } from '../../utils/dateUtil';
import useMergeProps from '../../hooks/useMergeProps';
function DateHeader(_props) {
    const props = useMergeProps(_props);
    const { prefixCls, generateConfig, locale, viewDate, onNextMonth, onPrevMonth, onNextYear, onPrevYear, onYearClick, onMonthClick, } = props;
    const { hideHeader } = useInjectPanel();
    if (hideHeader.value) {
        return null;
    }
    const headerPrefixCls = `${prefixCls}-header`;
    // const monthsLocale: string[] =
    //   locale.shortMonths ||
    //   (generateConfig.locale.getShortMonths
    //     ? generateConfig.locale.getShortMonths(locale.locale)
    //     : []);
    const month = generateConfig.getMonth(viewDate) + 1;
    // =================== Month & Year ===================
    const yearNode = (<button type="button" key="year" onClick={onYearClick} tabindex={-1} class={`${prefixCls}-year-btn`}>
      {formatValue(viewDate, {
            locale,
            format: locale.yearFormat,
            generateConfig,
        })}
    </button>);
    const monthNode = (<button type="button" key="month" onClick={onMonthClick} tabindex={-1} class={`${prefixCls}-month-btn`}>
      {locale.monthFormat
            ? formatValue(viewDate, {
                locale,
                format: locale.monthFormat,
                generateConfig,
            })
            : month < 10
                ? `0${month}`
                : month
        // monthsLocale[month]
        }
    </button>);
    const splitNode = <span class={`${prefixCls}-header-split`}>/</span>;
    const monthYearNodes = locale.monthBeforeYear
        ? [monthNode, splitNode, yearNode]
        : [yearNode, splitNode, monthNode];
    return (<Header {...props} prefixCls={headerPrefixCls} onSuperPrev={onPrevYear} onPrev={onPrevMonth} onNext={onNextMonth} onSuperNext={onNextYear}>
      {monthYearNodes}
    </Header>);
}
DateHeader.displayName = 'DateHeader';
DateHeader.inheritAttrs = false;
export default DateHeader;
